import { FunctionalComponent, h } from 'preact';

export const UploadSuccessIcon: FunctionalComponent<{ className?: string }> = ({ className }) => (
	<svg width="120" height="120" xmlns="http://www.w3.org/2000/svg" className={className}>
		<g fill="var(--primary)" fill-rule="evenodd">
			<path d="M87.6 39.6L51.8 75.4 32.5 56.2a2 2 0 10-2.9 3l20.7 20.6a2 2 0 003 0l37.2-37.3a2 2 0 10-2.9-2.9z" fill-rule="nonzero"/>
			<path d="M60 0a60 60 0 110 120A60 60 0 0160 0zm0 2a58 58 0 100 116A58 58 0 0060 2z"/>
		</g>
	</svg>
);
